module.exports = __webpack_public_path__ + "assets/2b66d26f387ae932bfd42c2febc50443.png";